module.exports = __webpack_public_path__ + "static/media/texture (16).e67568ed.jpg";